document.addEventListener("DOMContentLoaded", function () {
  new Swiper(".footer-swiper", {
    slidesPerView: "auto",
    spaceBetween: 15,
    loop: true,
    centeredSlides: false,
    navigation: {
      nextEl: ".footer-next",
      prevEl: ".footer-prev",
    }
  });
});
